import { createContext } from "react";

const SampleFunctionContext = createContext();

export default SampleFunctionContext;
